import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const getDropLandingShortUrlsEndpoint = {
    [dropEndpointIds.GET_DROP_LANDING_SHORT_URLS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
            },
            required: ['dropId'],
        },
    },
};
